import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import Code from '../components/Code';
import DriverTree from '../components/evolution/DriverTree';
import { C2_EVOLUTION_ENABLED } from '../evolutionFlag';

export default function Spine() {
  const spine = useQuery({ queryKey: ['spine'], queryFn: api.spine });
  if (spine.isLoading) return <div className="small faint">Loading spine…</div>;
  const s = spine.data!;

  return (
    <div>
      <div className="ph">Strategic Spine · Phase 0 anchor</div>
      <div className="h2">The strategy the surface sits on</div>
      {C2_EVOLUTION_ENABLED && <DriverTree />}

      <div className="grid2">
        <div className="panel">
          <div className="qhead"><span className="qdot" style={{ background: 'var(--amber)' }} />Strategic objectives (set weights)</div>
          {s.objectives.map((o) => (
            <div key={o.id} className="row" style={{ justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid var(--line-soft)' }}>
              <span style={{ fontSize: 15 }}>
                <span className="tag amber" style={{ marginRight: 8 }}>{o.id}</span>
                {o.name}
              </span>
              <span className="mono" style={{ color: 'var(--amber)', fontSize: 14 }}>{(o.weight * 100).toFixed(0)}%</span>
            </div>
          ))}
        </div>

        <div>
          <div className="panel" style={{ marginBottom: 14 }}>
            <div className="qhead"><span className="qdot" style={{ background: 'var(--red)' }} />Non-objectives (vetoes)</div>
            {s.non_objectives.map((n) => (
              <div key={n.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--line-soft)', fontSize: 15 }}>
                <span className="tag red" style={{ marginRight: 8 }}><Code id={n.id} kind="non_objective" compact /></span>
                {n.name}
              </div>
            ))}
          </div>
          <div className="panel">
            <div className="qhead">
              <span className="qdot" style={{ background: 'var(--teal)' }} />
              Operational spine · Money Map (NFU = per-SKU-per-channel)
            </div>
            <div className="flow">
              {s.money_nodes.map((n, i) => (
                <FlowFrag key={n.id} node={n} isLast={i === s.money_nodes.length - 1} />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="panel" style={{ marginTop: 14 }}>
        <div className="qhead"><span className="qdot" style={{ background: 'var(--gold)' }} />Assumption register</div>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Obj</th>
              <th>Type</th>
              <th>Statement</th>
              <th>Owner</th>
              <th>Tripwire</th>
            </tr>
          </thead>
          <tbody>
            {s.assumptions.map((a) => (
              <tr key={a.id}>
                <td><Code id={a.id} kind="assumption" compact /></td>
                <td><span className="tag amber">{a.objective_id}</span></td>
                <td><span className="tag muted">{a.type}</span></td>
                <td className="small">{a.statement}</td>
                <td className="small">{a.owner}</td>
                <td className="small">{a.tripwire}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function FlowFrag({ node, isLast }: { node: { id: string; stage: string }; isLast: boolean }) {
  return (
    <>
      <div className="node">
        <Code id={node.id} kind="stage" compact />
      </div>
      {!isLast && <span className="arrow">→</span>}
    </>
  );
}
